<script>
    export let afirmative = true;
    export let alt = ''
</script>

<div class="container" title={alt} class:content={$$slots.default}>
    {#if $$slots.default}
        <slot/>
    {:else}
        <div class="point" class:inactive={!afirmative}></div>
    {/if}
</div>

<style>
    .content {
        width: 100% !important;
        padding: 0 5px !important;
        background-color: rgba(0, 0, 0, 0.15) !important;
        border-radius: 7.5px !important;
        font-size: small;
    }
    .point {
        width: 7px;
        height: 7px;
        padding: 0;
        margin: 0;
        background-color: #437F4F;
        border-radius: 50%;
        position: relative;
        display: flex;
    }

    .container {
        display: inline-flex;
        width: 15px;
        height: 15px;
        justify-content: center;
        align-items: center;
        margin: 0;
        padding: 0;
        border-radius: 50%;
        position: relative;
        background-color: rgba(0, 0, 0, 0.07);
    }
    .inactive { background-color: #FF3D3D !important;  }
</style>